import { Component, OnChanges, OnInit } from '@angular/core';
import { Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';
import { FieldItem } from 'src/app/models/common/field-item';
import { mode } from 'd3';

@Component({
  selector: '',
  template: '',
})
export class AgentHierarchyDetailsHandlerComponent extends BaseComponent<AgentService> implements OnChanges {
  public isparentAgentIdSearchDisplayed: boolean;
  public isbranchIdSearchDisplayed: boolean;
  @Input() public model: any;

  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    console.log('changes', changes);

    if (changes['model'] && changes['model'].currentValue) {
      this.model = changes['model'].currentValue;
    }
  }

  channelCd_change(item: FieldItem) {
    this.service.getAgentSegmentation1ValueForChannel(item);
    this.service.getAgentSegmentation2ValueForChannel(item.model);
  }

  agentSegmentation1_focus(item: FieldItem) {
    this.service.getAgentSegmentation1LookupForChannel(item);
  }

  agentSegmentation2_focus(item: FieldItem) {
    this.service.getAgentSegmentation2LookupForChannel(item);
  }
}
